import { MAIN_PATH } from 'devices/navigation';

const indexComponent = require('./routes/list/components/DevicesList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: MAIN_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/activate'),
        require('./routes/show'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DevicesManager'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/devices/index.js